import styled, { css } from 'styled-components';
import { colors, media } from 'tsx/theme';

interface Props {
  error?: boolean;
  $fullWidth?: boolean;
  $withEndormentEnd?: boolean;
}

export const TextAreaVerdigris = styled.textarea<Props>`
  border: 1px solid ${colors.colorVerdigrisDark};
  border-radius: 15px;
  padding: 15px;
  min-width: 100px;
  background-color: transparent;
  resize: vertical;

  &::placeholder {
    opacity: 0.5;
    color: ${colors.text};
  }

  &:focus {
    outline: 1px solid ${colors.colorVerdigrisDark};
  }

  &:hover {
    outline: 1px solid ${colors.colorVerdigrisDark};
  }

  ${({ error }) =>
    error &&
    css`
      border: 1px solid red;
      &:focus {
        outline: 1px solid red;
      }
      &:hover {
        outline: 1px solid red;
      }
    `};

  &:disabled {
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `};
  ${({ $withEndormentEnd }) =>
    $withEndormentEnd &&
    css`
      padding-right: 50px;
    `};

  ${media.md(css`
    font-size: 14px;
  `)};
`;
